<script>
	import {API,http_headers} from '../global.js'
    export let venta = 0

    $: refresh = async()=>{
    	let query = `select top 20 * from w_payrequests where idwventa= ${venta} order by id desc`

    	const res = await fetch(`${API}/exec-query?u=true`,	{ method:'POST', headers: http_headers, body:JSON.stringify({query}) })
		const data = await res.json()
		if(data.success) {
			return data.data
		}
		else{
			throw new Error(data)
			return []
		} 
	}

</script>

<div class="container">
	ventas-pagos de venta : {venta}
	{#await refresh()}
		<p>Loading....</p>
	{:then ds}
		<pre>{JSON.stringify(ds,null,2)}</pre>
	{/await}
</div>